var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    stroke: "white",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.009,57.639L70.39,55.5l-1.966,1.162l3.11,1.838L51.5,70.34L31.466,58.5l3.11-1.838L32.61,55.5l-3.619,2.139  C28.687,57.82,28.5,58.146,28.5,58.5s0.187,0.682,0.491,0.861l22,13c0.157,0.094,0.333,0.139,0.509,0.139s0.352-0.045,0.509-0.139  l22-13c0.305-0.18,0.491-0.508,0.491-0.861S74.313,57.82,74.009,57.639z M74.009,48.639L70.39,46.5l-1.966,1.162l3.11,1.838  L51.5,61.34L31.466,49.5l3.11-1.838L32.61,46.5l-3.619,2.139C28.687,48.82,28.5,49.147,28.5,49.5s0.187,0.681,0.491,0.861l22,13  c0.157,0.094,0.333,0.139,0.509,0.139s0.352-0.045,0.509-0.139l22-13c0.305-0.181,0.491-0.508,0.491-0.861  S74.313,48.82,74.009,48.639z M28.991,41.362l22,13c0.157,0.094,0.333,0.139,0.509,0.139s0.352-0.045,0.509-0.139l22-13  c0.305-0.181,0.491-0.508,0.491-0.861s-0.187-0.681-0.491-0.861l-22-13c-0.313-0.186-0.704-0.186-1.018,0l-22,13  C28.687,39.82,28.5,40.147,28.5,40.5S28.687,41.181,28.991,41.362z M51.5,28.662L71.534,40.5L51.5,52.34L31.466,40.5L51.5,28.662z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.5e0f5b71ff9baeca77f5b5f59cd190a9.svg";
export { ForwardRef as ReactComponent };